import React from 'react'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {login} from "../../redux/actions/userAction"
import { Navigate, useNavigate } from 'react-router-dom'

const Login = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [phone, setPhone] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)

  // error states
  const [errorMessage,setErrorMessage]=useState("")

  const handelLogin = () => {
    if(phone===undefined || password.trim().length===0){
      setErrorMessage("Please fill all the fields")
    } else {
      setLoading(true)
      dispatch(login(phone, password))
      .then(res=>{
        if (!res.success) {
          setLoading(false)
          setErrorMessage(res.message)
        } else {
          if (res.user.role === "Admin") {
            const user = {name: res.user.name, phone: res.user.phone, id: res.user._id}
            localStorage.setItem("user", JSON.stringify(user))
            localStorage.setItem("token", res.token)
            navigate('/')
          } else {
            navigate('/notallowed')
          }
        }
      })
    }
  }

useEffect(() => {
  const listener = event => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      event.preventDefault();
      document.getElementById("submitBtn").click()
    }
  };
  document.addEventListener("keydown", listener);
  return () => {
    document.removeEventListener("keydown", listener);
  };
}, [])

  return (
      <section className='d-flex align-items-center justify-content-center vh-100'>
      <main className="form-signin container-fluid" style={{width:"100vw", maxWidth:"450px"}}>
        <img className="mb-4" src="https://omtechauto.in/assets/img/logo.png" alt="" width="200"/>
        <h1 className="h3 mb-3 fw-normal">Please sign in</h1>

        {errorMessage && <p className='text-danger my-4 text-center'>{errorMessage}</p>}
        <div className="form-floating mt-3">
            <input value={phone} onChange={(e)=> setPhone(e.target.value)} type="number" className="form-control shadow" id="floatingPhone" placeholder="9XXXXXXXXX"/>
            <label htmlFor="floatingPhone">Phone</label>
        </div>
        <div className="form-floating mt-4">
            <input value={password} onChange={(e)=> setPassword(e.target.value)} type="password" className="form-control shadow" id="floatingPassword" placeholder=" "/>
            <label htmlFor="floatingPassword">Password</label>
        </div>
        <button id='submitBtn' onClick={handelLogin} className="w-100 btn btn-lg shadow btn-primary mt-3">{loading ? <div className="spinner-border text-secondary loader-sizing" role="status"><span className="sr-only"></span></div>:'Sign in'}</button>
      </main>
     </section>
  )
}

export default Login